import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { from, switchMap } from 'rxjs';
import { FirebaseAuthService } from '../services/firebase-auth.service';

export const TokenInterceptor: HttpInterceptorFn = (req, next) => {
  const fbAuth = inject(FirebaseAuthService);

  if (req.headers.has('Authorization')) {
    return next(req);
  }

  return from(fbAuth.getFreshToken()).pipe(
    switchMap((token) => {
      if (token) {
        req = req.clone({
          setHeaders: {
            Authorization: `Bearer ${token}`,
          },
        });
      }
      return next(req);
    }),
  );
};
